import React from "react";
import { Button, Card, Tooltip } from "@mui/material";
import { useAnnounceKitBanner } from "../../hooks/useAnnounceKitBanner";


// ## TODO: Convert this to TypeScript and export Drawer from Financeable UI.
const Sidebar = (props) => {
  const isAnnounceKitBanner = useAnnounceKitBanner();

  const {
    open,
    title,
    onClickFn,
    bottom,
    right,
    left,
    disabled,
    component,
    icon,
    forwardIcon,
    backwardIcon,
    overflowY = "auto",
    background,
    itemPosition = 0,
  } = props;

  const startSidebarIconPosition = 145;
  const defaultSidebarIconGap = 55;

  const handle = {
    paddingFn: () => {
      switch (title) {
        case "Expand lenders":
          return "12px 12px 12px 12px";
        case "Manual Quote":
          return "0px 0px 0px 0px";
        case "Loan Summary":
          return "12px 12px 12px 12px";
        case "Notes":
          return "12px 0px";
        case "Comments":
          return "12px 0px";
        case "Activity log":
          return "12px 0px";
        case "Service log":
          return "12px 0px";
        default:
          break;
      }
    },
    widthFn: () => {
      switch (title) {
        case "Expand lenders":
          return `calc(${open ? 75 : 25}vw - 25px)`;
        case "Manual Quote":
          return `${open ? "calc(75vw - 25px)" : 0}`;
        case "Loan Summary":
          return `${"calc(25vw - 25px)"}`;
        case "Notes":
          return `${open ? "calc(25vw - 25px)" : 0}`;
        case "Comments":
          return `${open ? "calc(35vw - 35px)" : 0}`;
        case "Activity log":
          return `${open ? "calc(25vw - 25px)" : 0}`;
        case "Service log":
          return `${open ? "calc(25vw - 25px)" : 0}`;
        default:
          break;
      }
    },
    leftFn: () => {
      switch (title) {
        case "Notes":
          return left ? `${open ? "calc(25vw - 25px)" : "0px"}` : "";
        case "Comments":
          return left ? `${open ? "calc(35vw - 35px)" : "0px"}` : "";
        case "SMS (coming soon)":
          return left ? `${open ? "calc(25vw - 24px)" : "0px"}` : "";
        case "Emails (coming soon)":
          return left ? `${open ? "calc(25vw - 25px)" : "0px"}` : "";
        case "Activity log":
          return left ? `${open ? "calc(25vw - 25px)" : "0px"}` : "";
        case "Service log":
          return left ? `${open ? "calc(25vw - 25px)" : "0px"}` : "";
        default:
          break;
      }
    },
    topFn: () => {
      const baseIndex = itemPosition;

      if (baseIndex === undefined) return `${startSidebarIconPosition}px`;

      return `${startSidebarIconPosition + defaultSidebarIconGap * baseIndex}px`;
    },
    rightFn: (right, title, open) => {
      if (right) {
        let openedIconPos = 75;
        const defaultIconPos = 25;

        if (["Expand lenders", "Manual Quote"].includes(title)) {
          openedIconPos = open ? 75 : defaultIconPos;
        } else if (["Comments"].includes(title)) {
          openedIconPos = open ? 34.5 : defaultIconPos;
        } else {
          openedIconPos = open ? 25 : defaultIconPos;
        }
        const vwCalculation = open ? openedIconPos : 25.5;
        const pxValue = open ? "25px" : "35px";
        return `calc(${vwCalculation}vw - ${pxValue})`;
      }
      return "";
    },
  };

  const rightSideMenu = [
    "Expand lenders",
    "Manual Quote",
    "Notes",
    "Comments",
    "Activity log",
    "Service log",
    "Loan Summary",
  ];
  const isQuoteItems = ["Manual Quote"].includes(title);

  return (
    <div>
      {!icon && !forwardIcon && !backwardIcon ? (
        <></>
      ) : (
        <Tooltip title={title} placement={rightSideMenu.includes(title) ? "left" : "right"}>
          <Button
            disabled={disabled}
            color={`${open ? "primary" : "secondary"}`}
            elevation={1}
            variant={`${open ? "contained" : "outlined"}`}
            style={{
              transition: isQuoteItems ? "all 0.4s ease-in-out 0s" : "all 0.5s ease-in-out 0s",
              padding: "5px 5px",
              minWidth: 0,
              position: "fixed",
              borderColor: "rgba(0, 0, 0, 0.10)",
              right: handle.rightFn(right, title, open),
              left: handle.leftFn(),
              bottom: left && !bottom && "742px",
              top: handle.topFn(),
              writingMode: "vertical-rl",
              textOrientation: "sideways-right",
              marginTop: "25px",
              zIndex: open ? "999" : "",
            }}
            onClick={onClickFn}
          >
            {icon && icon}
            {!icon && open ? forwardIcon || icon : backwardIcon}
          </Button>
        </Tooltip>
      )}

      <Card
        id="productSelectorWrapper"
        elevation={2}
        style={{
          ...(background && {
            background: background,
          }),
          padding: handle.paddingFn(),
          width: handle.widthFn(),
          position: "fixed",
          overflowY: overflowY,
          overflowX: "hidden",
          height: "calc(100vh - 63px)",
          scrollbarColor: "white rebeccapurple",
          scrollbarWidth: "thin",
          right: right ? 0 : "",
          left: left ? 0 : "",
          top: 64 + (isAnnounceKitBanner?.height || 0),
          zIndex: 1,
          transition: isQuoteItems ? "all 0.4s ease-in-out 0s" : "all 0.5s ease-in-out 0s",
        }}
        sx={{
          "&.MuiCard-root::-webkit-scrollbar": {
            width: "7px",
            height: "7px",
          },
          "&.MuiCard-root::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&.MuiCard-root::-webkit-scrollbar-thumb": {
            backgroundColor: "#999",
          },
          "&.MuiCard-root::-webkit-scrollbar-thumb:hover": {
            background: "#616161",
          },
        }}
      >
        {component}
      </Card>
    </div>
  );
};

export default Sidebar;